// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@eisinc/Overrides/Widgets/QuickOrder/QuickOrderActions";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        clear: both;

        ${xScreen("lte", "md")} {
            flex-direction: row-reverse;
            justify-content: space-between;
        }
    `,
};

actionsStyles.overflowMenu = {
    buttonProps: {
        css: css`
            margin-left: 2px;
            border: none;
            background: transparent;
        `,
    },
};

actionsStyles.buttonsContainer = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
    `,
};

actionsStyles.addAllToCartButton = {
    variant: "primary",
};

actionsStyles.addToListButtonWrapper = actionsStyles.uploadOrderButtonWrapper = {
    css: css`
        margin-right: 10px;
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin: 10px 0;
            button {
                width: 100%;
            }
        }
    `,
};

actionsStyles.addToListButton = actionsStyles.uploadOrderButton = { variant: "secondary" };
